import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_book_rule_hdr_RowClass} from '../../../dbschema/bl_fi_mst_price_book_rule_hdr.model';

export class PriceBookRuleHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_rule_hdr: bl_fi_mst_price_book_rule_hdr_RowClass = new bl_fi_mst_price_book_rule_hdr_RowClass();
}
